import {Box, Button, Link, Spinner, Text, useDimensions} from '@chakra-ui/react';
import colorAlpha from 'color-alpha';
import React, {useRef, useState, useEffect} from 'react';
import FullCrossPlus from '../components/FullCrossPlus';
import ContactHero from './Contact/Components/hero';
import ContactList from './Contact/Components/List';
import axios from "axios";
import {SEO} from "../components/SEO";
import Container from "../components/Container";

const Contact = (props) => {
    const [metaData, setMetaData] = useState(undefined)
    const [contactData, setContactData] = useState(undefined)

    const pageRef = useRef();

    const dimen = useDimensions(pageRef, true);

    const count = Math.floor(dimen?.contentBox.height / 393) + 1 || 0;


    useEffect(() => {
        const fetchContactData = async () => {
            const metaResponse = await axios.get('/wp-json/wp/v2/pages?acf_format=standard&slug=contact').then(resp => {
                return resp.data;
            });
            setMetaData(metaResponse[0])
            const contactResponse = await axios.get('/wp-json/wp/v2/pages/?slug=contact').then(resp => {
                return resp.data[0];
            });
            setMetaData(metaResponse[0])
            setContactData(contactResponse)
        }
        fetchContactData()
    }, [])

    const isMobile = dimen?.contentBox.width < 768;

    return (
        <>
            <SEO
                image={metaData?.yoast_head_json?.og_image?.length > 0 ? metaData?.yoast_head_json?.og_image[0]?.url : null}
                title={metaData?.title?.rendered}
                ogTitle={metaData?.yoast_head_json?.og_title}
                description={metaData?.yoast_head_json?.og_description || metaData?.excerpt?.rendered}
                url={metaData?.yoast_head_json?.og_url}
                type={metaData?.yoast_head_json?.og_type}
                siteName={metaData?.yoast_head_json?.og_site_name}
                robots={`${metaData?.yoast_head_json?.robots.index}, ${metaData?.yoast_head_json?.robots.follow}`}
            />
            <Box ref={pageRef} px={['5', '10']}>
                {!isMobile && Array(count)
                    .fill('')
                    .map((_, key) => (
                        <FullCrossPlus index={key + 1} top={393 * (key + 1)} key={key}/>
                    ))}
                <ContactHero/>
                <ContactList data={contactData?.acf?.location}/>

                {!contactData?.acf?.contact_details ? <Box my={20}>
                        <Spinner color='blue.600' size='xl'/>
                    </Box> :
                    <Box borderX={'1px'} borderColor={'brandAlpha.200'} as="section">
                        <Box px={'1rem'}>
                            <Container>
                                {contactData?.acf?.contact_details?.map((section, index) => {
                                    return (
                                        <Box pb={'80px'} display={'flex'} alignItems={'start'} flexDirection={'column'} key={index}>
                                            <Text
                                                mb={'30px'}
                                                fontSize={'18px'}
                                                fontWeight={'bold'}
                                                lineHeight={'18px'}
                                                color={'brand.600'}
                                                as={'h6'}
                                            >
                                                <b>{section?.title}</b>
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'20.8px'}>
                                                {section?.description}
                                            </Text>
                                            {section?.call_to_action_type === 'button' ? (
                                                <Link href='/team'>
                                                    <Button isActive mt={'20px'}>{section?.call_to_action}</Button>
                                                </Link>
                                            ) : (
                                                <Text
                                                    pt={'20px'}
                                                    display={'block'}
                                                    textDecoration={'underline'}
                                                    as={'a'}
                                                    href={section?.call_to_action_url}
                                                >
                                                    {section?.call_to_action}
                                                </Text>
                                            )}
                                        </Box>
                                    )
                                })}
                                <Text
                                    textColor={colorAlpha('#000000', 0.5)}
                                    textAlign={'left'}
                                    fontSize={['10px', '12px']}
                                    lineHeight={['14px', '16.8px']}
                                    maxW={'650px'}
                                    pb={'120px'}
                                >
                                    Venrock consists of two separate investment programs: a traditional venture
                                    capital program, focused on early stage investing in healthcare and technology
                                    companies; and a later-stage healthcare program, which implements a venture
                                    capital-like long-term approach to investment opportunities in small
                                    capitalization public companies and late-stage private healthcare companies.
                                    Click <a href="https://www.venrock.com/" target="_blank" style={{textDecoration: 'underline'}}>here</a> for the traditional venture capital program website. This website is
                                    intended solely to provide general information regarding Venrock and is not an
                                    offer or solicitation with respect to the purchase or sale of any security.
                                    The material contained on this website is intended for financially
                                    sophisticated investors. Venrock does not solicit or make its services
                                    generally available to the public. Further, the information contained on this
                                    site, including information regarding investments and Venrock’s portfolio
                                    company experience, may not be relied on in any manner as legal, tax,
                                    accounting or investment advice. Past performance is not indicative of future
                                    results and it should not be assumed that results for any investments or
                                    portfolio companies described herein will be achieved for other investments or
                                    portfolio companies. Portfolio company information and team member profiles
                                    are not considered to be a complete list. In particular, the portfolio companies described herein were selected based, in part, on their positive investment performance relative to other Venrock investments. The content provided on this site is
                                    provided to users “AS IS”, and Venrock does not make any representation or
                                    warranty, express or implied, as to the accuracy or completeness of the
                                    information contained on this site.
                                    <br /><br />
                                    Statements from portfolio company management team members should not be construed 
                                    as indicating approval, support, or a recommendation of Venrock in its capacity as 
                                    the investment manager of the Venrock funds.   No compensation was provided for 
                                    making these statements, however the person making the statement, as an employee of 
                                    a Venrock portfolio company, stands to benefit financially (but indirectly) from 
                                    Venrock’s continued investment in the company.
                                </Text>
                            </Container>
                        </Box>
                    </Box>}
            </Box>
        </>
    );
};
export default Contact;
